interface IProps {
  disableClosing?: boolean;
  doNotReload?: boolean;
  fromDoAsk?: boolean;
  onLoginSuccess?: any;
}

export const showAuthPopup = (props?: IProps) => {
  window.postMessage(
    {
      authMessageType: 'LOGIN_POPUP_SHOW',
      params: props,
    },
    '*',
  );
};

export const getAuthHeader = (user) => {
  return user ? { Authorization: `${user.token_type || 'Bearer'} ${user.access_token}` } : {};
};
